import Head from 'next/head'

import type { FC, ReactNode } from 'react'
import type { SeoProps } from '@/types'

import { siteConfig } from '@/constants/site'
import { absoluteUrl } from '@/lib/url'

export const Seo: FC<SeoProps> = ({
    title,
    fullTitle,
    description = siteConfig.description,
    ogImage = siteConfig.ogImage,
    path = '/',
    noIndex = false,
    children
}): ReactNode => {
    const pageTitle = fullTitle ? fullTitle : title ? `${title} - ${siteConfig.name}` : siteConfig.name
    const canonical = absoluteUrl(path)
    const image = ogImage ? absoluteUrl(ogImage) : undefined

    return (
        <Head>
            <title>
                {pageTitle}
            </title>

            <meta name='description' content={description} />
            <link rel='canonical' href={canonical} />

            {noIndex ? <meta name='robots' content='noindex, nofollow' /> : (
                <meta name='robots' content='index, follow, max-image-preview:large, max-snippet:-1' />
            )}

            <meta property='og:site_name' content={siteConfig.name} />
            <meta property='og:title' content={pageTitle} />
            <meta property='og:description' content={description} />
            <meta property='og:type' content='website' />
            <meta property='og:locale' content='en_GB' />
            <meta property='og:url' content={canonical} />

            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={pageTitle} />
            <meta name='twitter:description' content={description} />

            {image ? <meta property='og:image' content={image} /> : null}
            {image ? <meta property='og:image:width' content='1200' /> : null}
            {image ? <meta property='og:image:height' content='630' /> : null}
            {image ? <meta name='twitter:image' content={image} /> : null}

            {children}
        </Head>
    )
}
